let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ioXLv")).then(() => parcelRequire('kXp7T'));